import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=02107202&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02107202')) {
      api.createRecord('02107202', component.options)
    } else {
      api.reload('02107202', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=02107202&", function () {
      api.rerender('02107202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26K0aBrqqIhnN/JS/comp/stardisplay.vue"
export default component.exports